import Query from '../../../components/Report';

const query = () => new Query('discover-connected-entities-pairs');

export default query;
